<template>
  <button
    v-bind="$attrs"
    type="button"
    :disabled="disabled"
    :class="{
      'rounded-l-lg': cap === 'first',
      'rounded-r-lg': cap === 'last',
      'flex h-8 items-center justify-center border px-3 text-xs leading-tight': true,
      'text-gray-700 hover:bg-gray-100 hover:text-gray-700':
        !active && !disabled,
      'text-gray-400': disabled,
      'border-gray-300 bg-white': !active,
      'z-10 border-gray-300 bg-blue-50 text-blue-600 hover:bg-blue-100 hover:text-blue-700':
        active,
    }"
    @click="click"
  >
    <slot>{{ formatNumber(item) }}</slot>
  </button>
</template>
<script lang="ts" setup>
import { formatNumber } from '~/lib/services/helpers';

const props = defineProps<{
  active?: boolean;
  item?: string | number | undefined;
  cap?: 'first' | 'last';
  disabled?: boolean;
}>();
const emit = defineEmits<{ (e: 'click'): void }>();
const click = () => emit('click');
defineOptions({
  inheritAttrs: false,
});
</script>
